import { Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

export const modalityFilter = (source: ReturnType<typeof useTrainingsDataTable>) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getModalityTranslation } = useTrainingsDatatable()

  const options = [
    {
      label: getModalityTranslation('online') || '',
      value: 'online',
      component: <Text size="300">{getModalityTranslation('online')}</Text>,
    },
    {
      label: getModalityTranslation('inperson') || '',
      value: 'inperson',
      component: <Text size="300">{getModalityTranslation('inperson')}</Text>,
    },
    {
      label: getModalityTranslation('mixed') || '',
      value: 'mixed',
      component: <Text size="300">{getModalityTranslation('mixed')}</Text>,
    },
  ]
  return buildTrainingsDataTableFilter(source, {
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
      {
        kind: 'SingleChoice',
        operation: 'notEq',
        options,
      },
    ],
    identifier: 'modalityFilter',
    path: 'modality',
    title: i18n.t('trainings.training_catalog.datatable.type'),
  })
}
